import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import blogs from "../data/blog";
const Blogs = () => {
  return (
    <>
      {/* Banner */}
      <div
        className="bg-dark text-white d-flex align-items-center about-banner"
        style={{ height: "300px" }}
      >
        <Container>
          <h1 className="display-4">Our Blogs</h1>
          <p className="">
            Explore insights, legal awareness, and expert perspectives on
            advocacy, justice, and modern legal developments.
          </p>
        </Container>
      </div>

      {/* Blogs Section */}
      <Container className="my-5">
        <Row>
          {blogs.map((blog) => (
            <Col md={4} className="mb-4" key={blog.id}>
              <Card className="h-100 shadow-sm">
                <Card.Img
                  variant="top"
                  src={blog.img}
                  style={{
                    maxHeight: "250px",
                    objectFit: "cover",
                    minHeight: "250px",
                  }}
                />
                <Card.Body>
                  <Card.Title>{blog.title}</Card.Title>
                  <Card.Text>{blog.desc}</Card.Text>
                  <Link to={`/blog/${blog.id}`}>
                    <Button variant="primary" className="w-100">
                      Read More
                    </Button>
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
};

export default Blogs;
